export class BusinessEdit {
  Id: number;
  OrganizationNumber: string;
  CompanyName: string;
  CompanyNumber: string;
  AboutBusiness: string;
  Address: string;
  Zipcode: string;
  Telephone: string;
  Email: string;
  BusinessCategoryId: number;
  ApplicationId: number;
  Features: string;
  Status: number;
  BusinessPortalId: number;
  CreatedBy: number;
  EmployeeCount: number;
  BusinessPortal:BusinessPortal;
  ModifiedBy: number;
  CreatedOn: Date;
  ModifiedOn: string;
  constructor() {
    this.Id = 0;
  }
}

export class BusinessPortal{

  ApplicationId: number;
  Avatar: string;
  BusinessListName: string;
  CountryCode: string;
  CreatedBy: number;
  CreatedOn: string;
  Description: string;
  Features: string;
  Id: number;
  IsCommonPortalCourseNames: boolean;
  IsPortalManager: boolean;
  LogoPath: string;
  Mobile: string;
  ModifiedBy: number;
  ModifiedOn: string;
  PortalBusinessList: string;
  PortalLogo: string;
  PortalUserList: string;
  Status: number;
  StatusKey: string;
  Title: string;
  UserId: number;
}

export class InternalTv {
  Id: number;
  BusinessId: number;
  FileName: string;
  OriginalFileName: string;
  MimeType: string;
  Size: number;
  Path: string;
  FileType: number;
  CreatedBy: number;
  Status: string;
  CreatedOn: string;
  ModifiedBy: number;
  ModifiedOn: string;
}





